'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { merge } from 'rxjs/observable/merge';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import ContentRoutes from 'ContentUtils/Routes';
import { CREATED_VARIATION } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { receiveContent, requestContent, requestedContentFailed } from '../actions/ContentActions';
import { receiveVariations, requestCreateVariation, requestedCreateVariationFailure, requestedCreateVariationSuccess, requestedVariationsFailed, requestVariations } from '../actions/VariationsActions';
export default ((action$, _, {
  ContentClient,
  VariationsClient
}) => action$.ofType(CREATED_VARIATION).pipe(mergeMap(({
  payload: {
    categoryId,
    contentType,
    id,
    name
  }
}) => VariationsClient.createVariation(contentType, id, name).pipe(tap(({
  id: variationId
}) => window.open(ContentRoutes.edit(variationId, categoryId))), mergeMap(() => merge(of(closeModal()), ContentClient.fetchContent({
  contentPageId: id,
  contentType
}).pipe(mergeMap(content => merge(of(receiveContent(content)), VariationsClient.fetch(content.abTestId, contentType).pipe(mergeMap(variations => of(requestedCreateVariationSuccess(contentType), receiveVariations(variations))), catchError(error => of(requestedVariationsFailed(error))), startWith(requestVariations())))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent())))), catchError(error => of(requestedCreateVariationFailure(error, contentType))), startWith(requestCreateVariation())))));